export const team = [
  {
    title: 'Fundador',
    authorPhoto: {
      src: '/images/team/anderson.m.jpeg',
    },
    authorName: 'Anderson Moutinho',
  },
  {
    title: 'Fundador',
    authorPhoto: {
      src: '/images/team/erick.m.jpeg',
    },
    authorName: 'Erick Moutinho',
  },
  {
    title: 'Co-Fundador',
    authorPhoto: {
      src: '/images/team/vitor.f.png',
    },
    authorName: 'Vitor Freitas',
  },
  {
    title: '',
    authorPhoto: {
      src: '/images/team/alexandre.h.jpeg',
    },
    authorName: 'Alexandre Hideki Jinnai',
  },
  {
    title: '',
    authorPhoto: {
      src: '/images/team/heitor.h.jpg',
    },
    authorName: 'Heitor Hatakeyama',
  },
  {
    title: '',
    authorPhoto: {
      src: '/images/team/igor.s.jpg',
    },
    authorName: 'Igor Szavka',
  },
  {
    title: '',
    authorPhoto: {
      src: '/images/team/jonas.g.jpg',
    },
    authorName: 'Jonas Gabriel da Costa Martins',
  },
  {
    title: '',
    authorPhoto: {
      src: '/images/team/leticia.s.jpeg',
    },
    authorName: 'Letícia Santos',
  },
  {
    title: '',
    authorPhoto: {
      src: '/images/team/natalia.r.jpg',
    },
    authorName: 'Natalia Reis',
  },
  {
    title: '',
    authorPhoto: {
      src: '/images/team/pedro.r.jpeg',
    },
    authorName: 'Pedro Reis',
  },
];
